<div class="exam-diagnoses w100 l-flex-w t-boxMargin--spacebyPadding summary">

    <div class="w100">
        <section class="m-box">
            <h2>{{ 'examDiagnoses.title' | translate }}</h2>

            <!-- =============== search: filters as you type =============== -->
            <div class="diag-search" *ngIf="!es.isClosed">
                <mat-form-field class="diag-search-field">
                    <input type="text" matInput class="t-field t-select" dir="auto"
                        [formControl]="search" [matAutocomplete]="diagAuto"
                        [placeholder]="'examDiagnoses.searchPlaceholder' | translate" />
                    <mat-autocomplete autoActiveFirstOption #diagAuto="matAutocomplete">
                        <!-- free text: whatever was typed, even if it is not in the catalogue -->
                        <mat-option *ngIf="search.value" [value]="search.value"
                            (onSelectionChange)="$event.isUserInput && pickTyped()">
                            {{ search.value }}
                        </mat-option>
                        <mat-option *ngFor="let m of matches" [value]="m.n"
                            (onSelectionChange)="$event.isUserInput && pickEntry(m)">
                            <span class="diag-option" dir="auto">
                                <span class="diag-option-name">{{ m.n }}</span>
                                <span class="diag-option-path" *ngIf="m.p">{{ m.p }}</span>
                            </span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <span class="diag-loading" *ngIf="searching">{{ 'examDiagnoses.loading' | translate }}</span>
                <span class="diag-loading" *ngIf="catalogFailed">{{ 'examDiagnoses.loadFailed' | translate }}</span>

                <button type="button" class="blue-btn diag-tree-toggle" (click)="toggleTree()">
                    <!--   {{ showTree ? '▾' : '▸' }} -->
                   {{ 'examDiagnoses.byCategory' | translate }}
                </button>

                <!-- while pressed, whatever is picked becomes a secondary diagnosis -->
                <button type="button" class="blue-btn diag-secondary-toggle" [class.is-on]="secondaryMode"
                    [attr.aria-pressed]="secondaryMode" (click)="toggleSecondary()">
                   {{ (secondaryMode ? 'examDiagnoses.secondary' : 'examDiagnoses.main') | translate }}
                </button>
            </div>

            <!-- =============== category tree =============== -->
            <div class="diag-tree" *ngIf="showTree && !es.isClosed">
                <div class="diag-crumbs">
                    <button type="button" class="diag-crumb" (click)="goToCrumb(-1)">{{ 'examDiagnoses.allCategories' | translate }}</button>
                    <ng-container *ngFor="let c of crumbs; let i = index">
                        <span class="diag-crumb-sep">›</span>
                        <button type="button" class="diag-crumb" dir="auto" (click)="goToCrumb(i)">{{ c }}</button>
                    </ng-container>
                </div>

                <div class="diag-level scroller">
                    <button type="button" class="diag-node" *ngFor="let n of currentLevel" dir="auto"
                        [class.has-children]="n.hasChildren"
                        (click)="openNode(n, levels.length - 1)">
                        <span>{{ n.label }}</span>
                        <span class="diag-node-arrow" *ngIf="n.hasChildren">›</span>
                    </button>
                </div>
            </div>

            <!-- =============== the picked diagnoses, one per line =============== -->
            <div class="diag-list" *ngIf="mainDiagnoses.length">
                <h4 class="diag-list-title">{{ 'examDiagnoses.main' | translate }}</h4>
                <table>
                    <tr *ngFor="let d of mainDiagnoses; let i = index" (dblclick)="remove(d)"
                        [matTooltip]="'examDiagnoses.removeHint' | translate">
                        <td class="l-td-m diag-list-num">{{ i + 1 }}.</td>
                        <td class="l-td-m diag-list-name" dir="auto">{{ d.Name }}</td>
                    </tr>
                </table>
            </div>

            <!-- the secondary box only exists once something was picked into it -->
            <div class="diag-list diag-list-secondary" *ngIf="secondaryDiagnoses.length">
                <h4 class="diag-list-title">{{ 'examDiagnoses.secondary' | translate }}</h4>
                <table>
                    <tr *ngFor="let d of secondaryDiagnoses; let i = index" (dblclick)="remove(d)"
                        [matTooltip]="'examDiagnoses.removeHint' | translate">
                        <td class="l-td-m diag-list-num">{{ i + 1 }}.</td>
                        <td class="l-td-m diag-list-name" dir="auto">{{ d.Name }}</td>
                    </tr>
                </table>
            </div>
            <!-- <div class="diag-empty" *ngIf="loaded && !diagnoses.length">{{ 'examDiagnoses.none' | translate }}</div> -->

            <!-- =============== notes + Auto Text =============== -->
            <div class="sep-8"></div>
            <section class="m-box diag-notes-box">
                <h2>{{ 'gastro.abdomen.Findings' | translate }}</h2>
                <textarea class="scroller fulltext diag-notes" [formControl]="notes" dir="auto"></textarea>
                <button class="t-btn-edit" type="button" *ngIf="!es.isClosed"
                    (click)="atS.showAuto(notes, 'Diagnosis Comments', notesAutoTextId)">Auto Text</button>
            </section>

        </section>
    </div>
</div>
